import axios from "axios";

export const fetchRole = async () => {
  try {
    const response = await axios.get("http://localhost:8080/webnet-hms/api/roles/all");
    const rawData = response.data.data;
    const flatData = rawData.flat();
    return flatData;
  } catch (error) {
    console.error("Error fetching roles:", error);
    return [];
  }
};
export const fetchRole1 = async (id) => {
  try {
    const response = await axios.get(`http://localhost:8080/webnet-hms/api/roles/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching roles:", error);
    return [];
  }
};
